module.exports = __webpack_public_path__ + "static/img/bg_dang.5e148c6b.png";